import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import * as EntitiesActionTypes from '../../entities/actionTypes'
import {TaskSortBy} from '../constants'
import {arrayToSet} from '../../atUtils'

const checkDefaultsForVarianceColumnsAndProcess = (order, shown) => {
    let newOrder = [...order]
    let newShown = [...shown]

    const shouldProcess = !newOrder.includes(TaskSortBy.VARIANCE_MAN_HOURS)
    if (shouldProcess) {
        const shouldProcessShown = newShown.includes(TaskSortBy.ESTIMATE)
        if (shouldProcessShown) {
            newShown = [...newShown, TaskSortBy.VARIANCE_MAN_HOURS]
        }

        const estimateIndex = newOrder.indexOf(TaskSortBy.ESTIMATE)
        const shouldProcessOrder = estimateIndex >= 0
        if (shouldProcessOrder) {
            const indexToInsert = estimateIndex + 1
            newOrder = [
                ...newOrder.slice(0, indexToInsert),
                TaskSortBy.VARIANCE_MAN_HOURS,
                TaskSortBy.VARIANCE_PERCENTS,
                TaskSortBy.VARIANCE_PROGRESS_BAR,
                ...newOrder.slice(indexToInsert)
            ]
        }
    }

    return [newOrder, newShown]
}

const checkDeafultsForIsSummaryRowShownAndProcess = (isSummaryRowShown) => {
    if (isSummaryRowShown === undefined)
        return true
    return isSummaryRowShown
}

const createReducer = ({
    TASK_MANAGEMENT = {}
}) => {
    const pageSettings = TASK_MANAGEMENT.PAGE_SETTINGS || {}

    const columnsOrder = (pageSettings.columnsOrder) ? JSON.parse(pageSettings.columnsOrder) : []
    const columnsShown = (pageSettings.columnsDisplay) ? JSON.parse(pageSettings.columnsDisplay) : []

    const [newColumnsOrder, newColumnsShown] = checkDefaultsForVarianceColumnsAndProcess(columnsOrder, columnsShown)
    const isSummaryRowShown = checkDeafultsForIsSummaryRowShownAndProcess(pageSettings.summaryRowShown)

    const initialState = {
        sorting: {
            by: pageSettings.sortBy || TaskSortBy.TASK,
            asc: pageSettings.ascSort || false,
        },
        isLoaded: false,
        columnsOrder: newColumnsOrder,
        columnsShown: newColumnsShown,
        isSummaryRowShown: isSummaryRowShown,
        summaryRow: {},

        loadedTaskIds: [],
    }

    return handleActions({
        [ActionTypes.TASKS_SORTING_CHANGE]: (state, {payload: sorting}) => ({
            ...state,
            sorting,
        }),
        [ActionTypes.COLUMNS_ORDER_SET]: (state, {payload: columnsOrder}) => ({
            ...state,
            columnsOrder: columnsOrder,
        }),
        [ActionTypes.COLUMNS_SHOWN_SET]: (state, {payload: columnsShown}) => ({
            ...state,
            columnsShown: columnsShown,
        }),
        [ActionTypes.IS_SUMMARY_ROW_SHOWN_SET]: (state, {payload: isSummaryRowShown}) => ({
            ...state,
            isSummaryRowShown: isSummaryRowShown,
        }),
        [ActionTypes.IS_LOADED_SET]: (state, {payload: isLoaded}) => ({
            ...state,
            isLoaded: isLoaded,
        }),
        [ActionTypes.SUMMARY_ROW_SET]: (state, {payload: summaryRow}) => ({
            ...state,
            summaryRow: summaryRow
        }),
        [ActionTypes.IS_SUMMARY_ROW_LOADED_SET]: (state, {payload: isLoaded}) => ({
            ...state,
            isSummaryRowLoaded: isLoaded,
        }),

        [ActionTypes.LOADED_TASK_IDS_SET]: (state, {payload: loadedTaskIds}) => ({
            ...state,
            loadedTaskIds
        }),
        [ActionTypes.LOADED_TASK_IDS_ADD]: (state, {payload: ids}) => ({
            ...state,
            loadedTaskIds: state.loadedTaskIds.concat(ids)
        }),
        [ActionTypes.LOADED_TASK_IDS_PREPEND]: (state, {payload: ids}) => ({
            ...state,
            loadedTaskIds: ids.concat(state.loadedTaskIds)
        }),
        [EntitiesActionTypes.TASKS_REMOVE]: (state, {payload: ids}) => {
            const taskIdsSet = arrayToSet(ids)
            return {
                ...state,
                loadedTaskIds: state.loadedTaskIds.filter((id) => !taskIdsSet[id])
            }
        },
    }, initialState)
}

export default createReducer



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/reducer.js